import { render, staticRenderFns } from "./DettaglioSondaggioOpzione.vue?vue&type=template&id=037969c2&"
import script from "./DettaglioSondaggioOpzione.vue?vue&type=script&lang=js&"
export * from "./DettaglioSondaggioOpzione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports